import React from "react";
import { Link, NavLink } from "react-router-dom";

import CartFooter from "../common/CartFooter";

function PatitentDetails() {

    return(
        <>
          <div className="container">
             <div className="cart-wrap">
                <div className="cartNav">
                    <ul>
                        <li><Link to="/cart">my shopping cart</Link></li>
                        <li><Link className="active" to="/patient-details">patient details</Link></li>
                        <li><Link to="/pay">pay</Link></li>
                    </ul>
                    <div className="cartClose"><img alt="" src={require('../images/icons/close.png')} /></div>
                </div>
                <div className="cart-list">
                    <h2 className="title left">Patient details</h2>
                    <div className="patitent-details-form">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="inp-wrap">
                                    <label htmlFor="">Title</label>
                                    <select className="inp" name="" id="">
                                        <option value="">Mr</option>
                                        <option value="">Mrs</option>
                                    </select>
                                </div>
                                <div className="inp-wrap">
                                    <label htmlFor="">First name</label>
                                    <input className="inp" type="text" placeholder="Sarah" />
                                </div>
                                <div className="inp-wrap">
                                    <label htmlFor="">Last name</label>
                                    <input className="inp" type="text" placeholder="Brown" />
                                </div>
                                <div className="inp-wrap">
                                    <label htmlFor="">Date of birth</label>
                                    <input className="inp" type="text" placeholder="01/01/2000" />
                                </div>
                                <div className="inp-wrap">
                                    <label htmlFor="">E-mail</label>
                                    <input className="inp" type="text" placeholder="email@email.com" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="inp-wrap">
                                    <label htmlFor="">Phone number</label>
                                    <input className="inp" type="text" placeholder="+44 0777777777777" />
                                </div>
                                <div className="inp-wrap">
                                    <label htmlFor="">Street</label>
                                    <input className="inp" type="text" placeholder="25 Great Road" />
                                </div>
                                <div className="inp-wrap">
                                    <label htmlFor="">City</label>
                                    <input className="inp" type="text" placeholder="London" />
                                </div>
                                <div className="inp-wrap">
                                    <label htmlFor="">Post code</label>
                                    <input className="inp" type="text" placeholder="W12 9NN" />
                                </div>
                                <div className="inp-wrap">
                                    <label htmlFor="">Country</label>
                                    <input className="inp" type="text" placeholder="England" />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center warnMsg mt-4">
                            <img alt="" src={require('../images/icons/warning.png')} />
                            <p>The patient's <span>address</span> will be used for the <span>delivery</span> of the products from this order.</p>
                        </div>
                    </div>
                </div>
             </div>
          </div>

          <div className="cart-footer">
              <div className="container">
                  <div className="price-cont">
                    <span>Total price :</span>
                    <span>£ -</span>
                  </div>
                  <div className="priceButton">
                    <button className="themeBtn line">Cancel</button>
                    <button className="themeBtn">Checkout</button>
                  </div>
              </div>

              <CartFooter/>

          </div>


        </>
    )
}

export default PatitentDetails;